import { AlertColor } from '@mui/material/Alert'
import './index.css'

// Map styles to corresponding Tailwind CSS classes
const styleMap: Record<AlertColor, { container: string; heading: string; textString: string }> = {
  success: {
    container: 'bg-green-50 border-green-500 p-4',
    heading: 'text-sm font-semibold text-gray-800',
    textString: 'text-sm font-medium text-gray-800 mt-1',
  },
  info: {
    container: 'bg-gray-50 border-gray-300 p-4',
    heading: 'text-sm font-semibold text-gray-800',
    textString: 'text-sm font-medium text-gray-800 mt-1',
  },
  warning: {
    container: 'bg-yellow-50 border-yellow-500 p-4',
    heading: 'text-sm font-semibold text-gray-800',
    textString: 'text-sm font-medium text-gray-800 mt-1',
  },
  error: {
    container: 'bg-red-50 border-red-500 p-4',
    heading: 'text-sm font-semibold text-gray-800',
    textString: 'text-sm font-medium text-gray-800 mt-1',
  },
}
export interface MsgPanelComponentProps {
  style?: AlertColor
  heading?: string
  text?: string | React.ReactNode
  content?: React.ReactNode
}

const MsgPanelComponent = (props: MsgPanelComponentProps): JSX.Element => {
  const { style = 'info', heading, text, content } = props ?? {}
  const selectedStyle = styleMap[style ?? 'info']

  return (
    <div className={`p-4 my-2 rounded-xl border-2 text-center ${selectedStyle.container}`}>
      {/* <div className={`p-4 my-2 rounded-lg w-full border text-center ${selectedStyle.container}`}> */}
      {heading && <p className={`font-semibold whitespace-pre-line ${selectedStyle.heading}`}>{heading}</p>}
      {content ||
        (text && (
          <div
            className={`text-sm mt-1 whitespace-pre-line ${typeof text === 'string' ? selectedStyle.textString : ''}`}
          >
            {text}
          </div>
        ))}
    </div>
  )
}

export default MsgPanelComponent
